import api, {deleteFn, getFn, IdApiArg, insertFn, UpdateArg, updateFn, UpdateResp} from "../../api";
import {Tables, TablesInsert} from "../../apitypes";
import {supabase} from "../../supabase";


export interface OperationFilter {
    active?: boolean
    code?: string,
}


export const operationApi = api.injectEndpoints({

    endpoints: (build) => ({

        // Machine types
        getOperation: build.query<Tables<"workTask">[], OperationFilter>({
            queryFn: async (args) => {
                let q = supabase
                    .from("workTask")
                    .select("*")

                if (args.active !== undefined) {
                    q = q.eq("Active", args.active)
                }
                const {data, error} = await q;

                if (error) return {error};
                return {data}
            },
            providesTags: ["Operation"]
        }),
        getOperationById: build.query<Tables<"workTask"> | null, IdApiArg>({
            query: getFn("workTask"),
            providesTags: ["Operation"]
        }),

        postOperation: build.mutation<UpdateResp, TablesInsert<"workTask">>({
            query: insertFn("workTask"),
            invalidatesTags: ["Operation"],
        }),
        deleteOperationById: build.mutation<UpdateResp, IdApiArg>({
            query: deleteFn("workTask"),
            invalidatesTags: ["Operation"],
        }),
        putOperationById: build.mutation<UpdateResp, UpdateArg<"workTask">>({
            query: updateFn("workTask"),
            invalidatesTags: ["Operation"],
        }),


    })
});

export type OperationApiPut = Tables<"workTask">

export type OperationApiGet = Tables<"workTask">


export const {

    useGetOperationQuery,
    useGetOperationByIdQuery,
    usePostOperationMutation,
    usePutOperationByIdMutation,
    useDeleteOperationByIdMutation,

} = operationApi;
